import { render, staticRenderFns } from "./OcrItemState.vue?vue&type=template&id=b2131862&"
import script from "./OcrItemState.vue?vue&type=script&lang=js&"
export * from "./OcrItemState.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports